import { call, put } from 'redux-saga/effects'
import { addNotificationAction, removeNotificationAction } from 'actions/notificationActions'
import { delay, takeLatest } from 'redux-saga'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { NOTIFICATION } from 'actions/notificationActionTypes'

export function * notification(action) {
  try {
    const { message, notificationType } = action
    yield put(addNotificationAction(message, notificationType))

    yield call(delay, 2000)

    yield put(removeNotificationAction())
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchNotification() {
  yield takeLatest(NOTIFICATION, notification)
}



// WEBPACK FOOTER //
// ./src/sagas/notificationSaga.js